import * as ui from "../components/components";

var view = () => new ui.Container({
    classes: "col-xs-11",
    components: [
        new ui.Container({
            id: "EditContainer",
            classes: "col-xs-6",
            components: [
                new ui.Container({
                    id: "Confidence",
                    bindValue: "Confidence",
                    bsc: "geo-gauge",
                    label: "Confidence",
                    labelBsc: "col-xs-4",
                    readonly: true
                }),
                new ui.Icon({
                    id: "ConfidenceInfo",
                    classes: "large-info"
                }),
                new ui.NumericInput({
                    id: "Latitude",
                    bindValue: "Latitude",
                    label: "Latitude",
                    bsc: "col-xs-12",
                    labelBsc: "col-xs-4",
                    min: "-90",
                    max: "90",
                    decimals: "8",
                    step: 0.0001,
                    format: "#.########",
                    disabled: true
                }),
                new ui.NumericInput({
                    id: "Longitude",
                    bindValue: "Longitude",
                    label: "Longitude",
                    bsc: "col-xs-12",
                    labelBsc: "col-xs-4",
                    min: "-180",
                    max: "180",
                    decimals: "8",
                    step: 0.0001,
                    format: "#.########",
                    disabled: true
                }),
                new ui.Container({
                    id: "UserLatLong",
                    components: [
                        new ui.Label({
                            bindValue: "EnteredCoordinates",
                            classes: "bold"
                        }),
                        new ui.Link({
                            id: "UseLink",
                            bindLabel: "UseEnteredCoord",
                            bindClass: "bind-label right",
                            bsc: "js-message-link right"
                        }),
                        new ui.NumericInput({
                            id: "UserLatitude",
                            bindValue: "UserLatitude",
                            label: "UserLatitude",
                            bsc: "col-xs-12",
                            labelBsc: "col-xs-4",
                            min: "-90",
                            max: "90",
                            decimals: "8",
                            step: 0.0001,
                            format: "#.########",
                            disabled: true,
                            readonly: true
                        }),
                        new ui.NumericInput({
                            id: "UserLongitude",
                            bindValue: "UserLongitude",
                            label: "UserLongitude",
                            bsc: "col-xs-12",
                            labelBsc: "col-xs-4",
                            min: "-180",
                            max: "180",
                            decimals: "8",
                            step: 0.0001,
                            format: "#.########",
                            disabled: true,
                            readonly: true
                        })
                    ]
                })
            ]
        }),
        new ui.Container({
            id: "MapViewContainer",
            classes: "col-xs-5",
            components: [
                new ui.Container({
                    id: "Map",
                    bsc: "geo-map"
                })
            ]
        })
    ]
});

export default view;
